import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';
import { CardComponent } from '../../card/card.component';
import { IconComponent } from '../../icon/icon.component';
import { Icons } from '../../icon/constants/icons.constants';

@Component({
    selector: 'nw-navigation-card',
    templateUrl: './navigation-card.component.html',
    styleUrls: ['./navigation-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CardComponent, IconComponent]
})
export class NavigationCardComponent {
    @Input() icon!: Icons.Type | Icons.ThirdParty;
    @Input() title!: string;
    @Input() text!: string;

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onClick: EventEmitter<void> = new EventEmitter<void>();

    public onRaiseEvent($event: Event): void {
        if (
            // Secondary button
            ($event as MouseEvent)?.button === 2 ||
            // Fourth button
            ($event as MouseEvent)?.button === 3 ||
            // Fifth button
            ($event as MouseEvent)?.button === 4
        ) {
            $event.stopPropagation();
            $event.stopImmediatePropagation();

            return;
        }

        this.onClick.emit();
    }
}
